import { useEffect, useState } from "react";

export type CountdownParts = {
  d: string;
  h: string;
  m: string;
  s: string;
  done: boolean;
};

const pad = (n: number) => String(Math.max(0, n)).padStart(2, "0");

function compute(target: number): CountdownParts {
  let diff = Math.max(0, target - Date.now());
  const days = Math.floor(diff / 86_400_000); diff -= days * 86_400_000;
  const hrs  = Math.floor(diff / 3_600_000);  diff -= hrs * 3_600_000;
  const mins = Math.floor(diff / 60_000);     diff -= mins * 60_000;
  const secs = Math.floor(diff / 1000);
  return { d: pad(days), h: pad(hrs), m: pad(mins), s: pad(secs), done: target - Date.now() <= 0 };
}

export function useCountdown(targetMs: number): CountdownParts {
  const [parts, setParts] = useState<CountdownParts>(() => compute(targetMs));
  useEffect(() => {
    setParts(compute(targetMs));
    const id = window.setInterval(() => setParts(compute(targetMs)), 1000);
    return () => window.clearInterval(id);
  }, [targetMs]);
  return parts;
}
